import { render, staticRenderFns } from "./ToInvoice.vue?vue&type=template&id=1fb04e31&"
import script from "./ToInvoice.vue?vue&type=script&lang=js&"
export * from "./ToInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports